import { closeModal, connect, submitOutstandingQuizSession } from '@instructure/quiz-core';
import { SESSION_MANUAL_SUBMISSION_MODAL } from '@instructure/quiz-common';
import { ManualSubmissionModal as ManualSubmissionModalPresenter } from './presenter';
export function mapStateToProps(state, ownProps) {
  return {
    open: state.getIn(['modal', 'isOpen']) === SESSION_MANUAL_SUBMISSION_MODAL
  };
}
export var mapDispatchToProps = {
  submitOutstandingQuizSession: submitOutstandingQuizSession,
  closeModal: closeModal
};
export var ManualSubmissionModal = connect(mapStateToProps, mapDispatchToProps)(ManualSubmissionModalPresenter);
export default ManualSubmissionModal;